define('entities/sales_inbox',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (App, $, _, Backbone, Settings) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.SalesInboxItem = Backbone.RelationalModel.extend({
    defaults: {
      secId: null,
      emailMessageSecId: null,
      emailMessageIdHeader: null,
      subject: '',
      senderEmail: '',
      customerName: '',
      customerVip: false,
      receivedAt: null,
      category: null,
      emailCase: null,
      locale: null,
      potential: null,
      potentialValue: 0,
      latestOfferValue: 0,
      customerValue: 0,
      priorityScore: 0,
      status: 'NEW',
      assignedUserpidSecId: null,
      assignedUserpidName: '',
      assignedGroupSecId: null,
      assignedGroupName: '',
      classificationConfidence: null,
      classificationSource: null,
      classifiedAt: null,
      firstResponseAt: null,
      resolvedAt: null,
      manualOverride: false,
      labels: [],
      note: null
    },
    idAttribute: 'secId'
  });

  App.reqres.setHandler('salesInbox:model', function (json) {
    var existing = null;
    if (json && json.secId) {
      existing = Backbone.Relational.store.find(app.ns.SalesInboxItem, json.secId);
    }
    if (existing) {
      existing.set(json);
      return existing;
    }
    return new app.ns.SalesInboxItem(json);
  });

  var API = {
    listUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox', params); },
    countUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/rowCount', params); },
    detailUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId); },
    contextUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/context'); },
    assignUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/assign'); },
    assignUserUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/assign-user'); },
    assignGroupUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/assign-group'); },
    statusUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/status'); },
    classificationUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/classification'); },
    localeUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/locale'); },
    noteUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/' + secId + '/note'); },
    statsUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/stats', params); },
    // Lightweight, server-cached per-locale barometer data (separate from the
    // heavy full-stats call).
    barometerUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/stats/barometer', params); },
    routingRulesUrl: function (params) { return Settings.url('compuzz2', 'v2/sales-inbox/routing-rules', params); },
    routingRulesCountUrl: function () { return Settings.url('compuzz2', 'v2/sales-inbox/routing-rules/rowCount'); },
    routingRuleUrl: function (secId) { return Settings.url('compuzz2', 'v2/sales-inbox/routing-rules/' + secId); }
  };

  App.reqres.setHandler('salesInbox:list-url', API.listUrl);
  App.reqres.setHandler('salesInbox:count-url', API.countUrl);

  // ── Shared sales-inbox filter state ───────────────────────────────────
  // The list screen persists its selected filters here; the header badge
  // reads the same key so its count always reflects what the user is
  // currently looking at. Both go through buildFilterParams() so the query
  // params can never drift between the two views.
  var FILTER_STORAGE_KEY = 'salesInbox.listFilters';

  function loadSalesInboxFilters() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(FILTER_STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }

  function buildFilterParams(filters) {
    filters = filters || {};
    var params = {};
    _.each(['potential', 'category', 'emailCase', 'locale', 'status', 'userSecId', 'groupSecId', 'search'], function (key) {
      if (filters[key]) { params[key] = filters[key]; }
    });
    if (filters.unassigned) { params.unassigned = true; }
    if (filters.myGroups)   { params.myGroups = true; }
    if (filters.vip)        { params.vip = true; }
    return params;
  }

  // Build the query params from a given filter object, or from the
  // persisted filters when none is supplied. The list view passes its own
  // in-memory filters; the header badge relies on the persisted ones.
  App.reqres.setHandler('salesInbox:filter-params', function (filters) {
    return buildFilterParams(filters || loadSalesInboxFilters());
  });

  // Count of sales-inbox items matching the filters currently selected on
  // the list screen. Backed by the same rowCount endpoint the list paginates
  // with, so the badge and the list footer always agree.
  App.reqres.setHandler('salesInbox:header-count', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.countUrl(buildFilterParams(loadSalesInboxFilters())),
      success: function (data) {
        var n = typeof data === 'number' ? data : (data && data.count) || 0;
        defer.resolve(n);
      },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:get', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.detailUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:context', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.contextUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:assign', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.assignUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Side-specific assignment handlers — each preserves the OTHER side
  // (use these instead of `salesInbox:assign` when only one side changes).
  App.reqres.setHandler('salesInbox:assign-user', function (secId, userpidSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.assignUserUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ userpidSecId: userpidSecId || null }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:assign-group', function (secId, groupSecId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.assignGroupUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ groupSecId: groupSecId || null }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:status', function (secId, status) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.statusUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ status: status }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:set-locale', function (secId, locale) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.localeUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ locale: locale }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:reclassify', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.classificationUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:note', function (secId, note) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.noteUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ note: note }),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:stats', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.statsUrl(params || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:barometer', function (params) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.barometerUrl(params || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:routing-rules:list-url', API.routingRulesUrl);
  App.reqres.setHandler('salesInbox:routing-rules:count-url', API.routingRulesCountUrl);

  App.reqres.setHandler('salesInbox:routing-rules:create', function (payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.routingRulesUrl({}),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:routing-rules:update', function (secId, payload) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.routingRuleUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify(payload || {}),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('salesInbox:routing-rules:delete', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.routingRuleUrl(secId),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });
});

